import * as React from "react";

import './CardButton.pcss';

interface Props {
  buttonAction:()=>void;
  buttonLabel?:string;
  hideLabel?:boolean;
  hideArrow?:boolean;
  variant?:'standard'|'outlined';
}

export function CardButton(props:Props) {
  let buttonProps = {
    onClick:props.buttonAction
  }
  if(props.hideLabel) {
    buttonProps['aria-label'] = props.buttonLabel;
  }
  return (
    <div className={`${'outlined'===props.variant?'outlined-card-button':'cardButton'}`}><button className={`${props.variant?props.variant:''}`} {...buttonProps}>{!props.hideLabel&&<span className={"lab"}>{props.buttonLabel}</span>}{!props.hideArrow && <span aria-hidden={true} className="material-symbols-outlined">arrow_forward_ios</span>}</button></div>
  )
}
